module.exports = __webpack_public_path__ + "static/media/Logo__Twilio.bc8b426c.svg";